<div class="headline-6 px-3 my-3">Recent Bids</div>

@for(recentActivity of bidsList; track recentActivity.id) {
  <div class="row activity-row" [ngClass]="{'highlight': !!isHighLight(recentActivity.id)}">
    <div class="col-1 bidder-logo">
      <img class="logo" [src]="recentActivity.imageUrl ? recentActivity.imageUrl : '/images/user_default.png'" style="height:24px;">
    </div>
    <div class="col-8 bid-title headline-8--regular d-flex" style="align-content: center;">
      {{ recentActivity.amount | currency: 'USD':'symbol-narrow':'1.0-0' }}
      <span class="text-nowrap mx-2">bid on</span> 
      <span class="option-name">{{ recentActivity.optionInfo.name }} </span> 
      <span class="text-nowrap mx-2">by</span> 
      <span (click)="openAuctionDetailModal(recentActivity.userInfo.id)" class="text-nowrap blue-text cursor--pointer text-truncate">{{ recentActivity.userInfo.name }}</span>
    </div>
    <div class="col-3 caption--bold"> {{ recentActivity.created | date : "shortTime"  }} / {{ recentActivity.created | date : "mediumDate"  }}  </div>
  </div>
} @empty {
  <div class="text-center p-3">No bids yet.</div>
}